import React, { useEffect, useState } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import {
  HiOutlineLockClosed,
  HiOutlineArrowRight,
  HiOutlineShieldCheck,
  HiOutlineLightningBolt,
  HiOutlineKey,
  HiOutlineEye,
  HiOutlineEyeOff,
} from "react-icons/hi";
import Labels from "../../services/apiLabels";
import { PUT } from "../../constant/apiMethods";
import { RESET_PASSWORD, TOASTER_SHOW, toaster_w } from "../../constant";
import { scrollTop } from "../../utils/window";
import "../Login Page/client-login.css";
import "./style.css";

const publicUrl = process.env.PUBLIC_URL || "";
const VISUAL_IMAGE = `${publicUrl}/images/hero-evaluation.jpg`;

function ChagePassword(props) {
  const { passworedReset_New, toasterShow } = props;
  const { id, token } = useParams();
  const history = useHistory();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    scrollTop();
  }, []);

  const reSetPassword = (event) => {
    event.preventDefault();
    if (submitting) return;
    if (!password) {
      toasterShow({
        show: true,
        autoHide: false,
        type: toaster_w,
        description: "Please enter a new password.",
      });
      return;
    }
    if (password !== confirmPassword) {
      toasterShow({
        show: true,
        autoHide: false,
        type: toaster_w,
        description: "Passwords do not match.",
      });
      return;
    }
    if (!id || !token) {
      toasterShow({
        show: true,
        autoHide: false,
        type: toaster_w,
        description: "This reset link is invalid or incomplete.",
      });
      return;
    }
    setSubmitting(true);
    passworedReset_New(
      {
        uidb64: id,
        token,
        password,
      },
      (response) => {
        setSubmitting(false);
        if (response?.message?.type === "success") {
          history.replace("/login");
        }
      }
    );
  };

  return (
    <div className="pi-login pi-reset">
      <div className="pi-login__fx" aria-hidden="true">
        <span className="pi-login__glow pi-login__glow--a" />
        <span className="pi-login__glow pi-login__glow--b" />
        <span className="pi-login__grid" />
      </div>

      <div className="pi-login__inner">
        <div className="pi-login__shell">
          <section className="pi-login__panel pi-login__panel--form">
            <header className="pi-login__head">
              <p className="pi-label">Account recovery</p>
              <h1>Set new password</h1>
              <p className="pi-login__lead">
                Choose a new password for your account, then sign in with it.
              </p>
            </header>

            <form
              className="pi-login__form"
              onSubmit={reSetPassword}
              autoComplete="on"
            >
              <div className="pi-login__field">
                <span
                  className="pi-login__field-label"
                  id="reset-password-label"
                >
                  New password
                </span>
                <span className="pi-login__control">
                  <HiOutlineLockClosed size={18} aria-hidden />
                  <input
                    id="reset-password"
                    type={showPassword ? "text" : "password"}
                    name="new-password"
                    autoComplete="new-password"
                    required
                    placeholder="Enter new password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    aria-labelledby="reset-password-label"
                  />
                  <button
                    type="button"
                    className="pi-login__toggle-password"
                    onClick={() => setShowPassword((prev) => !prev)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    aria-pressed={showPassword}
                  >
                    {showPassword ? (
                      <HiOutlineEyeOff size={18} aria-hidden />
                    ) : (
                      <HiOutlineEye size={18} aria-hidden />
                    )}
                  </button>
                </span>
              </div>

              <div className="pi-login__field">
                <span
                  className="pi-login__field-label"
                  id="reset-confirm-label"
                >
                  Confirm password
                </span>
                <span className="pi-login__control">
                  <HiOutlineLockClosed size={18} aria-hidden />
                  <input
                    id="reset-confirm"
                    type={showConfirm ? "text" : "password"}
                    name="confirm-password"
                    autoComplete="new-password"
                    required
                    placeholder="Confirm new password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    aria-labelledby="reset-confirm-label"
                  />
                  <button
                    type="button"
                    className="pi-login__toggle-password"
                    onClick={() => setShowConfirm((prev) => !prev)}
                    aria-label={
                      showConfirm ? "Hide password" : "Show password"
                    }
                    aria-pressed={showConfirm}
                  >
                    {showConfirm ? (
                      <HiOutlineEyeOff size={18} aria-hidden />
                    ) : (
                      <HiOutlineEye size={18} aria-hidden />
                    )}
                  </button>
                </span>
              </div>

              <button
                type="submit"
                className="pi-login__submit"
                name="CTAButton"
                disabled={submitting}
              >
                {submitting ? "Updating…" : "Update password"}
                {!submitting ? (
                  <HiOutlineArrowRight size={18} aria-hidden />
                ) : null}
              </button>
            </form>

            <p className="pi-login__footer-note">
              Back to <Link to="/login">Log in</Link>
            </p>
            <p className="pi-login__footer-note pi-reset__signup-note">
              Need a new link?{" "}
              <Link to="/forgetpassword">Forgot password</Link>
            </p>
          </section>

          <aside
            className="pi-login__panel pi-login__panel--visual"
            style={{ backgroundImage: `url(${VISUAL_IMAGE})` }}
            aria-hidden="true"
          >
            <span className="pi-login__visual-shade" />
            <div className="pi-login__visual-copy">
              <p className="pi-login__visual-kicker">AutoTrade Port</p>
              <h2>
                Almost there.
                <span> Secure your account.</span>
              </h2>
              <ul className="pi-login__visual-points">
                <li>
                  <HiOutlineKey size={16} />
                  One-time reset from your email
                </li>
                <li>
                  <HiOutlineLightningBolt size={16} />
                  Sign in right after updating
                </li>
                <li>
                  <HiOutlineShieldCheck size={16} />
                  Keep your appointments and credits safe
                </li>
              </ul>
            </div>
          </aside>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) => ({
  passworedReset_New: (data, callBack) =>
    dispatch({
      type: RESET_PASSWORD,
      payload: {
        type: RESET_PASSWORD,
        label: Labels.password_Reset_New,
        method: PUT,
        data,
        hideOverlayLoader: true,
        callBack,
      },
    }),
  toasterShow: (data) =>
    dispatch({
      type: TOASTER_SHOW,
      payload: {
        ...data,
      },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChagePassword);
